import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Stack } from '@mui/material';

export type styleOptionsProp = {
  colorHeader: string,
  fontHeader: {
    color: string,
    fontSize: string,
    fontFamily: string,
  }
  logo: string,
  enableLoop: boolean,
  enablePosMessage: boolean,
  enablePostMessage: boolean,
  enableRedirect: boolean,
  messageAfter?: string,
  imageAfter?: string,
  link?: string,
}

export default function NewFormFillingHeader({
  styleOptions,
  formName,
  setOpen,
}: {
  styleOptions: styleOptionsProp,
  formName: string,
  setOpen: Function
}) {
  const colorHeader = styleOptions?.colorHeader;
  const fontHeader = styleOptions?.fontHeader;
  const logo = styleOptions?.logo;

  return (
      <AppBar
        position='static'
        sx={{
          backgroundColor: colorHeader ? colorHeader : '#643E91',
          color: fontHeader?.color && fontHeader?.color,
          fontSize: fontHeader?.fontSize && fontHeader?.fontSize,
          fontFamily: fontHeader?.fontFamily && fontHeader?.fontFamily,
        }}>
        <Toolbar>
          <IconButton
            onClick={() => setOpen(true)}
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Stack
            width={'100%'}
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}>
            {logo && (
              <img
                className='imgLogoStyle'
                src={logo}
                alt={formName}
              />
            )}
            <Typography
              variant={`${window.navigator.maxTouchPoints > 0 ? 'h6' : 'h5'}`}
              component="div"
              sx={{ flexGrow: 1 }}>
              {formName}
            </Typography>
          </Stack>
        </Toolbar>
      </AppBar>
  )
}
